/**
 * Waits for an element to exist in the UI.
 * @param {string} selector CSS Style selector for the node we're waiting for.
 */
function waitForElement(selector) {
  return new Promise(function(resolve) {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    var observer = new MutationObserver(function(_mutations) {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

/**
 * Sets the max number of months on the bold subscription month picker.
 * @param {number} maxNumberOfMonths is the calculated max number of months on the bold subscription month picker
 */
function setMaxNumberOfMonths(maxNumberOfMonths) {
  $('.bold-ro__subscription-length').val(maxNumberOfMonths);
}

/**
 * Calculates the max number of months on the bold subscription month picker.
 * @param {string} vehicleYear is the vehicle year input.
 * @param {string} maxBoldSubscriptionMonths is the max number of subscription months configured in bold
 */
function calculateMaxNumberOfMonths(vehicleYear, maxBoldSubscriptionMonths) {
  var today = new Date();
  // The formula does not need the extra bold configured window on max number of months to account for vehicle years greater than the current year
  var maxSubscriptionMonths = Math.min(maxBoldSubscriptionMonths, 180);
  var maxNumberOfMonths = maxSubscriptionMonths - ((today.getFullYear() - vehicleYear) * 12) - today.getMonth();
  return maxNumberOfMonths;
}
